/**
 * OverlapWarningDialog
 * Feature: 005-clinic-scheduling (T012)
 *
 * Shows overlap conflict details when policy is 'allowed_with_warning'.
 */

import { AlertTriangle } from 'lucide-react'
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'
import type { OverlapConflict } from '../types/scheduling.types'

interface OverlapWarningDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  conflicts: OverlapConflict[]
  onConfirm: () => void
  onCancel: () => void
}

export function OverlapWarningDialog({
  open,
  onOpenChange,
  conflicts,
  onConfirm,
  onCancel,
}: OverlapWarningDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2 text-amber-600">
            <AlertTriangle className="h-5 w-5" />
            Conflito de horário detectado
          </AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="space-y-3">
              <p>
                Foram encontrados {conflicts.length} conflito(s) de horário:
              </p>
              <ul className="space-y-2">
                {conflicts.map((conflict) => (
                  <li
                    key={conflict.conflicting_session_id}
                    className="rounded-md border border-amber-200 bg-amber-50 p-3 text-sm"
                  >
                    <p className="font-medium text-foreground">
                      {conflict.professional_name}
                    </p>
                    <p className="text-muted-foreground">
                      Paciente: {conflict.patient_name}
                    </p>
                    <p className="text-muted-foreground">
                      {conflict.session_date} — {conflict.start_time} às{' '}
                      {conflict.end_time}
                    </p>
                  </li>
                ))}
              </ul>
              <p className="text-sm text-muted-foreground">
                Deseja prosseguir com o agendamento mesmo assim?
              </p>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onCancel}>Cancelar</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            className="bg-amber-600 text-white hover:bg-amber-700"
          >
            Prosseguir mesmo assim
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
